import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Icon from 'srcReact/components/icons/Icon'
import ImagePicker from 'srcReact/MessengerPage/components/ImagePicker'
import EmojiPicker from 'srcReact/components/common2/EmojiPicker'
import styles from './styles.module.scss'

const CustomToolbar = ({
  showEmojiPicker,
  showFilePicker,
  showTextFormatter,
  appendEmoji,
  uploadImageCallBack,
  allowedImageTypes,
  allowedImageSizeInMB,
  allowedDocumentTypes,
  allowedDocumentSizeInMB,
  filesLimit,
  getFileError,
  imageDataUrls,
  imagesToUpload,
  focusedMode = false,
  fromMessenger = false,
  allowDocs = true,
  allowImages = true,
  imagePickerText = '',
  showDocumentPicker = false,
  documentPickerText = '',
  showAdvFormat = false
}) => {
  const {
    common: { isMobile, isDesktop }
  } = useSelector((state) => state)

  const [isMarkupVisible, setIsMarkupVisible] = useState(false)

  useEffect(() => {
    if (!focusedMode && isMobile) {
      setIsMarkupVisible(false)
    }
  }, [focusedMode])

  const toggleMarkup = () => {
    setIsMarkupVisible(!isMarkupVisible)
  }

  return (
    <div id='toolbar'>
      {showTextFormatter ? (
        <React.Fragment>
          <button
            type='button'
            className={`${styles.markupButton} ${fromMessenger && styles.markupButtonMessenger} ${
              isMarkupVisible && styles.messengerIsMarkupVisible
            } ${fromMessenger && focusedMode && styles.markupButtonFocusedMode}`}
            onClick={toggleMarkup}>
            <Icon
              styleModifier={`${styles.markupIcon} ${isMarkupVisible && styles.activeMarkupIcon} `}
              name='text-markup-icon'
            />
          </button>
          <div
            className={
              isMarkupVisible
                ? `${styles.markupContainer} ${fromMessenger && styles.messengerMarkupContainer}`
                : styles.markupContainerHidden
            }>
            {showAdvFormat && (
              <select className={`ql-size`}>
                <option value='small'>Small</option>
                <option selected></option>
                <option value='large'>Large</option>
                <option value='huge'>Huge</option>
              </select>
            )}
            <button className={`ql-bold ${styles.toolButton} `} />
            <button className={`ql-italic ${styles.toolButton} ${styles.italic}`} />
            <button className={`ql-underline ${styles.toolButton} ${styles.underline}`} />
            {showAdvFormat && (
              <React.Fragment>
                <button className={`ql-link ${styles.toolButton}`} />
                <button className={`ql-list ${styles.toolButton}`} value='ordered' />
                <button className={`ql-list ${styles.toolButton}`} value='bullet' />
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ) : null}
      {showEmojiPicker && (
        <EmojiPicker
          containerCss={`${styles.emojiContainer} ${fromMessenger && styles.messengerEmojiContainer} ${
            fromMessenger && !focusedMode && styles.messengerNotFocusedEmojiContainer
          }`}
          emojiButtonCSS={styles.emojiButton}
          pickerContainerCSS={fromMessenger ? styles.messengerPickerContainer : styles.pickerContainer}
          appendEmoji={appendEmoji}
          iconName='reaction'
          iconStyle={`${styles.emojiIcon} ${fromMessenger && styles.messengerEmojiIcon} ${
            fromMessenger && !focusedMode && styles.isNotFocusedMode
          }`}
        />
      )}
      {showFilePicker && (
        <ImagePicker
          containerCss={`${styles.imagePickerContainer} ${fromMessenger && styles.messengerImageContainer}`}
          uploadFileCallback={uploadImageCallBack}
          allowedImageTypes={allowedImageTypes}
          allowedImageSizeInMB={allowedImageSizeInMB}
          filesLimit={filesLimit}
          getFileError={getFileError}
          iconStyle={`${styles.imagePickerIcon} ${fromMessenger && styles.messengerImagePickerIcon} ${
            fromMessenger && !focusedMode && styles.isNotFocusedMode
          }`}
          allowDocs={false}
          allowImages={true}
          iconText={imagePickerText}
          imageDataUrls={imageDataUrls}
          imagesToUpload={imagesToUpload}
        />
      )}
      {showDocumentPicker && (
        <ImagePicker
          containerCss={styles.imagePickerContainer}
          uploadFileCallback={uploadImageCallBack}
          allowedDocumentTypes={allowedDocumentTypes}
          allowedDocumentSizeInMB={allowedDocumentSizeInMB}
          filesLimit={filesLimit}
          getFileError={getFileError}
          iconStyle={`${styles.imagePickerIcon} ${fromMessenger && styles.messengerImagePickerIcon}`}
          allowDocs={true}
          allowImages={false}
          iconText={documentPickerText}
          imageDataUrls={imageDataUrls}
          imagesToUpload={imagesToUpload}
        />
      )}
    </div>
  )
}

export default CustomToolbar
